import {PaginatedV2} from '../../types';
import {LANGUAGE_CODES} from '../constants';
import {GUIDEBOOKS_SUPPORTED_LANGUAGES} from './constants';
import {Guidebook} from './types';

function isGuidebookLanguageSupported(language: string | null | undefined): boolean {
  const code = language?.slice(0, 2);
  return GUIDEBOOKS_SUPPORTED_LANGUAGES.includes(code as LANGUAGE_CODES);
}

function isGuidebookVisible(guidebook: Guidebook): boolean {
  return !(guidebook.content_type === 'PDF' && !guidebook.pdf_url);
}

function filterVisibleGuidebooks(data: PaginatedV2<Guidebook>): PaginatedV2<Guidebook> {
  return {...data, items: data.items.filter(isGuidebookVisible)};
}

export {isGuidebookLanguageSupported, isGuidebookVisible, filterVisibleGuidebooks};
